import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "How much do removalists in Melbourne cost?",
    a: "The cost of a move depends on several factors, including the size of your property, number of movers, truck requirements, distance, access and moving time. MoversNearby moving services start from $69/hr*. Request a free quote to understand the expected cost for your specific move.",
  },
  {
    q: "How do I choose the right removalist in Melbourne?",
    a: "Look for a moving company with experienced movers, transparent pricing, appropriate insurance coverage, good customer reviews and a service that matches your moving requirements. MoversNearby provides local and interstate moving services, with free quotes available before booking.",
  },
  {
    q: "Do you provide house movers in Melbourne?",
    a: "Yes. MoversNearby provides house moving services across Greater Melbourne, including apartment, unit and family home moves.",
  },
  {
    q: "Can you move furniture or individual items?",
    a: "Yes. We provide furniture removal services for smaller jobs and individual items, subject to availability and your moving requirements.",
  },
  {
    q: "Do you offer same-day removalist services?",
    a: "Same-day moving may be available depending on our schedule, location and moving requirements. Call us on 03 9113 6005 to check availability.",
  },
  {
    q: "Do you provide interstate removalist services?",
    a: "Yes. MoversNearby provides interstate moving services from Melbourne to destinations across Australia. For interstate moves, provide your pickup location, destination and preferred moving date so we can assess your requirements.",
  },
  {
    q: "Are MoversNearby moving services insured?",
    a: "Yes. MoversNearby states that its moving operations and goods in transit are covered by insurance. Ask our team about the applicable coverage for your specific move.",
  },
  {
    q: "How can I get a quote from MoversNearby?",
    a: "You can request a free moving quote online by entering your pickup and delivery details, or call 03 9113 6005 to discuss your move with our team.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="border-t border-slate-200 bg-white/75" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-5 py-24 lg:px-10 lg:py-32">
        <Reveal>
          <p className="mb-4 text-center text-xs font-bold uppercase tracking-[0.3em] text-blaze">FAQ</p>
          <h2 className="text-center font-display text-4xl font-semibold uppercase leading-[0.95] tracking-tighter sm:text-5xl">
            Frequently asked<br />questions
          </h2>
        </Reveal>
        <div className="mt-14 space-y-3">
          {FAQS.map((f, i) => (
            <Reveal key={f.q} delay={i * 0.04}>
              <div className="rounded-xl border border-slate-200 bg-white shadow-sm" data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  data-testid={`faq-question-${i}`}
                  aria-expanded={open === i}
                  aria-controls={`faq-answer-${i}`}
                >
                  <span className="font-display text-base font-semibold tracking-tight text-slate-900 sm:text-lg">{f.q}</span>
                  {open === i ? (
                    <Minus className="h-5 w-5 shrink-0 text-blaze" />
                  ) : (
                    <Plus className="h-5 w-5 shrink-0 text-slate-400" />
                  )}
                </button>
                {open === i && (
                  <p id={`faq-answer-${i}`} className="px-6 pb-6 text-sm leading-relaxed text-slate-600" data-testid={`faq-answer-${i}`}>
                    {f.a}
                  </p>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
